import { insiderItems } from "@/mocks/gossip";

const STATUS_STYLE: Record<string, string> = {
  核验中: "bg-secondary-500 text-background-50",
  补料中: "bg-accent-500 text-background-50",
  待排期: "bg-primary-500 text-background-50",
};

export default function Insider() {
  return (
    <section id="insider" className="relative py-14 md:py-20 bg-foreground-950">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-foreground-700 to-transparent"></div>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-secondary-400 text-xs font-medium tracking-wide mb-3">
              <i className="ri-key-2-line"></i> 独家内幕线索
            </span>
            <h2 className="font-heading text-background-50 text-2xl md:text-4xl font-extrabold">
              还没见光的料，正在这里核
            </h2>
          </div>
          <a
            href="#submit"
            className="hidden md:inline-flex items-center gap-2 text-sm text-secondary-300 hover:text-secondary-200 whitespace-nowrap"
          >
            你也有料？点这里递进来 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {insiderItems.map((item) => (
            <a
              key={item.id}
              href="#insider"
              className="group rounded-2xl overflow-hidden bg-foreground-900 border border-foreground-800 hover:border-secondary-600/60 transition-colors flex flex-col cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-60 md:h-64 object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 to-transparent"></div>
                <span className="absolute top-4 left-4 inline-flex items-center gap-1 text-xs px-3 py-1 rounded-full bg-accent-500 text-background-50 font-medium">
                  <i className="ri-vip-crown-line text-sm"></i> {item.category}
                </span>
                <span
                  className={`absolute bottom-4 left-4 inline-flex items-center gap-1 text-xs px-3 py-1 rounded-full font-medium ${STATUS_STYLE[item.status]}`}
                >
                  <i className="ri-time-line text-sm"></i> {item.status}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-5 md:p-6">
                <h3 className="font-heading text-background-50 font-bold leading-snug text-base md:text-lg mb-2 group-hover:text-secondary-200 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed mt-auto">{item.brief}</p>
              </div>
            </a>
          ))}

          <div className="rounded-2xl border border-dashed border-foreground-700 bg-foreground-900/40 p-6 md:p-8 flex flex-col justify-center items-start gap-3">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 text-2xl">
              <i className="ri-spy-line"></i>
            </span>
            <h3 className="font-heading text-background-50 text-lg font-bold">这块空白，等你来填</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              你手里正在捂的一手资料，可能就是这个板块的下一条独家。按匿名规则递进来，编辑团队 24
              小时内回看。
            </p>
            <a
              href="#submit"
              className="mt-2 inline-flex items-center gap-2 rounded-full bg-background-50 hover:bg-secondary-200 text-foreground-950 text-sm px-5 py-2.5 transition-colors"
            >
              匿名递一条 <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}